import { render, staticRenderFns } from "./CommodityPackage.vue?vue&type=template&id=80029728&scoped=true&"
import script from "./CommodityPackage.vue?vue&type=script&lang=js&"
export * from "./CommodityPackage.vue?vue&type=script&lang=js&"
import style0 from "./CommodityPackage.vue?vue&type=style&index=0&id=80029728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80029728",
  null
  
)

export default component.exports